import { GoMotoComponent } from '../../../API/GoMoto.types';
import { useLocalization } from '../../../Contexts/Localization';
import { GMGrid } from '../../../CommonControls/Grid/Grid';
import css from './ContactSupportModal.module.scss';

export const ContactSupport: GoMotoComponent = () => {
    const Localization = useLocalization();

    return (
        <GMGrid container className={css.contactSupport}>
            <GMGrid xs={12}>
                <GMGrid
                    container
                    columnSpacing={2}
                    className={css.gridRow}
                >
                    <GMGrid xs={4} sm={5}>{Localization.PhoneListing}</GMGrid>
                    <GMGrid xs={8} sm={7}>{'(800) 961-4151'}</GMGrid>
                </GMGrid>
            </GMGrid>
            <GMGrid xs={12}>
                <GMGrid
                    container
                    columnSpacing={2}
                    className={css.gridRow}
                >
                    <GMGrid xs={4} sm={5}>{Localization.EmailListing}</GMGrid>
                    <GMGrid xs={8} sm={7}>
                        <a href={'mailto:kiosksupport@keytrak.com'}>{'kiosksupport@keytrak.com'}</a>
                    </GMGrid>
                </GMGrid>
            </GMGrid>
            <GMGrid xs={12}>
                <GMGrid
                    container
                    columnSpacing={2}
                    className={css.gridRow}
                >
                    <GMGrid xs={4} sm={5}>{Localization.MondayThruFridayListing}</GMGrid>
                    <GMGrid xs={8} sm={7}>{Localization.EightToSevenEastern}</GMGrid>
                </GMGrid>
            </GMGrid>
        </GMGrid>
    );
};
